import { alpha, createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#234436',
      light: '#426b58',
      dark: '#183026',
      contrastText: '#fffdf8',
    },
    secondary: {
      main: '#c86b4a',
      light: '#db8e73',
      dark: '#9f4f34',
      contrastText: '#fffaf5',
    },
    background: {
      default: '#f6f1e8',
      paper: '#fffaf5',
    },
    text: {
      primary: '#1f241f',
      secondary: '#5f665f',
    },
    success: {
      main: '#2c6a4f',
    },
    info: {
      main: '#4d7c8a',
    },
    warning: {
      main: '#c9943f',
    },
    error: {
      main: '#b44b37',
    },
    divider: alpha('#234436', 0.12),
  },
  typography: {
    fontFamily: '"Manrope", "Inter", "Segoe UI", sans-serif',
    h1: {
      fontFamily: '"Fraunces", "Georgia", serif',
      fontWeight: 600,
      letterSpacing: '-0.03em',
    },
    h2: {
      fontFamily: '"Fraunces", "Georgia", serif',
      fontWeight: 600,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontFamily: '"Fraunces", "Georgia", serif',
      fontWeight: 600,
      letterSpacing: '-0.03em',
    },
    h4: {
      fontFamily: '"Fraunces", "Georgia", serif',
      fontWeight: 600,
      letterSpacing: '-0.03em',
    },
    h5: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    button: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      textTransform: 'none',
    },
    body1: {
      lineHeight: 1.7,
    },
    body2: {
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          colorScheme: 'light',
        },
        body: {
          backgroundImage:
            'radial-gradient(circle at top left, rgba(200,107,74,0.14), transparent 28%), radial-gradient(circle at top right, rgba(35,68,54,0.08), transparent 30%)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: alpha('#fffaf5', 0.82),
          color: '#1f241f',
          backdropFilter: 'blur(18px)',
          boxShadow: 'none',
          borderBottom: `1px solid ${alpha('#234436', 0.08)}`,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 18,
          backgroundColor: alpha('#fffaf5', 0.98),
          boxShadow: `0 24px 48px ${alpha('#2b221c', 0.16)}`,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: 16,
          minHeight: 42,
        },
        containedPrimary: {
          boxShadow: `0 14px 34px ${alpha('#234436', 0.22)}`,
        },
        outlined: {
          borderColor: alpha('#234436', 0.18),
          backgroundColor: alpha('#fffaf5', 0.72),
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        rounded: {
          borderRadius: 16,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          border: `1px solid ${alpha('#234436', 0.08)}`,
          boxShadow: `0 16px 32px ${alpha('#2b221c', 0.12)}`,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          backgroundColor: alpha('#fffaf5', 0.94),
          boxShadow: `0 14px 28px ${alpha('#493a2b', 0.1)}`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 700,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: alpha('#fffaf5', 0.88),
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          minHeight: 52,
        },
      },
    },
  },
});
